<template>
  <PickLotteryQuickPickCard
    v-model:collapsed="isRandom"
    :headline="$t('picklottery.quickpick.bettype.title')"
  >
    <PerPlayAddOnSelector
      v-bind="{ addOn, ...addOnSelectorProps }"
      v-model:value="modelValue"
      :ignore-outside-click-on="[]"
      :label="$t('picklottery.bettype.label')"
    />
    <p class="mt-200 text-secondary-secondary paragraph-small-text">
      {{ $t(`lottery.bettype.${modelValue.value}.explanation`) }}
    </p>
  </PickLotteryQuickPickCard>
</template>

<script lang="ts" setup>
import type { QuickPickSettings } from '../stores/lottery'
import type { PerPlayAddOnSelectorProps } from './PerPlayAddOnSelector.vue'

type PickLotteryQuickPickBetTypeEmits = {
  (event: 'update:value', value: PickLotteryQuickPickBetTypeProps['value']): void
}

type PickLotteryQuickPickBetTypeProps = Omit<PerPlayAddOnSelectorProps, 'value'> & {
  value?: QuickPickSettings['betType']
}

const emit = defineEmits<PickLotteryQuickPickBetTypeEmits>()
const {
  addOn,
  value = null,
  ...addOnSelectorProps
} = defineProps<PickLotteryQuickPickBetTypeProps>()

const isRandom = computed({
  get: () => !value,
  set: (newValue) => {
    emit('update:value', newValue ? null : addOn.options[0])
  },
})
const modelValue = computed({
  get: () => ({
    name: addOn.name,
    value: value ?? addOn.options[0],
  }),
  set: (newValue) => {
    emit('update:value', newValue.value)
  },
})
</script>
